import { render, staticRenderFns } from "./ManageQuestion.vue?vue&type=template&id=aeb69706&scoped=true"
import script from "./ManageQuestion.vue?vue&type=script&lang=js"
export * from "./ManageQuestion.vue?vue&type=script&lang=js"
import style0 from "./ManageQuestion.vue?vue&type=style&index=0&id=aeb69706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb69706",
  null
  
)

export default component.exports